import React, { useEffect, useState, useRef, useDebugValue } from 'react';
import echarts from 'echarts'
import axios from 'axios'
// import { list } from '../credit'
import { DatePicker, Space } from "antd";
import { ConfigProvider } from 'antd';
import { Select } from 'antd';
import moment from 'moment';
import 'moment/locale/zh-cn';
import locale from 'antd/lib/locale/zh_CN';
import { Button, Tooltip } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { ReloadOutlined } from '@ant-design/icons';
import { chartData } from '../chartData'
import { pieDoubleOption } from '../chart/pieDoubleOption'
import { pieOption } from '../chart/pieOption'
import { barOption } from '../chart/barOption'
import { linebarOption } from '../chart/linebarOption'
import '../style/credit.css'
import '../style/common.css'
import Broadcast from './Broadcast'
import Broadcast2 from './Broadcast2'
import 'antd/dist/antd.css';

const { RangePicker } = DatePicker;
const dateFormat = "YYYY-MM-DD";

const { Option } = Select;
// var shareDefault = null
var shareData = null
var companyScoreWarnData = null
var empoyeeScoreWarnData = null
var imgList = ['one', 'two', 'three']
var classNameData = ['colorOne', 'colorTwo', 'colorThree']

function getQueryString(name) {
    var index = window.location.pathname.indexOf("/", 1) + 1;
    var ternantid = window.location.pathname.substring(0, index);
    var url = window.location.origin;
    console.log(url);
    if(ternantid.indexOf('ssc-board')<0){
        url = window.location.origin + ternantid;
    }else{
                url+='/';
    }
    return url;
}
const Credit = () => {

    // const [shareData,setShareData] = useState(null)
    const [divHeight, setDivHeight] = useState(0);
    const [divHeight2, setDivHeight2] = useState(0);
    const rows_oneEl = useRef(null);
    const [requestData, setRequestData] = useState(null)
    const [dates, setDates] = useState([]);
    const [hackValue, setHackValue] = useState();
    const [value, setValue] = useState();
    const [defaultValue, setDefaultValue] = useState([moment().startOf("year"), moment().endOf("day")]);
    const [shareDefault, setShareDefault] = useState(null);
    const [sendData, setSendData] = useState({id: '0', startTime: defaultValue[0].format(dateFormat), endTime: defaultValue[1].format(dateFormat)})
    //真实数据请求
    const fetchData = async (sendData) => {
        let host_url = getQueryString("");
        let action_path = 'kapi/app/ssc/creditBoardDataApiService?'
        let requestId = `sscid=${sendData.id}&starttime=${sendData.startTime}&endtime=${sendData.endTime}`
        let action_url = host_url + action_path + requestId
        const res = await axios(action_url)
        const data = JSON.parse(res.data.data)

        shareData = data.sscid || shareData
        setShareDefault(shareData && shareData[0].value)
        if (data.companyScoreWarn) {
            let companyScoreWarnDataLen = data && data.companyScoreWarn.length > 3 ? 3 : data.companyScoreWarn.length
            companyScoreWarnData = data && data.companyScoreWarn.slice(0, companyScoreWarnDataLen);
            for(let i = 0; i < companyScoreWarnDataLen; i++) {
                companyScoreWarnData[i]['className'] = classNameData[i]
                companyScoreWarnData[i]['img'] = imgList[i]
            }
        }
        if (data.empoyeeScoreWarn) {
            let empoyeeScoreWarnDataLen = data && data.empoyeeScoreWarn.length > 3 ? 3 : data.empoyeeScoreWarn.length
            empoyeeScoreWarnData = data && data.empoyeeScoreWarn.slice(0, empoyeeScoreWarnDataLen);
            for(let i = 0; i < empoyeeScoreWarnDataLen; i++) {
                empoyeeScoreWarnData[i]['className'] = classNameData[i]
                empoyeeScoreWarnData[i]['img'] = imgList[i]
            }
        }
        setRequestData(data)
    }
    //本地测试
    // const fetchData = async () => {
    //     let action_url = '/json/datas.json'
    //     const res = await axios(action_url)
    //     const data = res.data.data
        
    //     shareData = data.sscid || shareData
    //     setShareDefault(shareData && shareData[0].value)
    //     if (data.companyScoreWarn) {
    //         let companyScoreWarnDataLen = data && data.companyScoreWarn.length > 3 ? 3 : data.companyScoreWarn.length
    //         companyScoreWarnData = data && data.companyScoreWarn.slice(0, companyScoreWarnDataLen);
    //         for(let i = 0; i < companyScoreWarnDataLen; i++) {
    //             companyScoreWarnData[i]['className'] = classNameData[i]
    //             companyScoreWarnData[i]['img'] = imgList[i]
    //         }
    //     }
    //     if (data.empoyeeScoreWarn) {
    //         let empoyeeScoreWarnDataLen = data && data.empoyeeScoreWarn.length > 3 ? 3 : data.empoyeeScoreWarn.length
    //         empoyeeScoreWarnData = data && data.empoyeeScoreWarn.slice(0, empoyeeScoreWarnDataLen);
    //         for(let i = 0; i < empoyeeScoreWarnDataLen; i++) {
    //             empoyeeScoreWarnData[i]['className'] = classNameData[i]
    //             empoyeeScoreWarnData[i]['img'] = imgList[i]
    //         }
    //     }
    //     setRequestData(data)

    // }
    
    //调用 请求数据
    useEffect(() => {
        fetchData(sendData)
    },[])

    // 表格轮播f
    useEffect(() => {
        // console.log(rows_oneEl.current.offsetHeight);
        setDivHeight(rows_oneEl.current.offsetHeight || 0);
        setDivHeight2(rows_oneEl.current.offsetHeight || 0);
      }, []);

    //日历
    const dateChange = (date, dateString) => {
        setValue(date)
        setSendData((prevState)=>{
            let finalData = {
                ...prevState,
                startTime: dateString[0],
                endTime: dateString[1]
            }
            return finalData
        })
    }
      const onOpenChange = (open) => {
        if (open) {
            setHackValue([]);
            setDates([]);
        } else {
            setHackValue(undefined);
        }
    };
    const disabledDate = (current) => {
        const endToday = current > moment().endOf()
        if (!dates || dates.length === 0) {
            return endToday;
        }
        const tooLate = dates[0]  && current.diff(dates[0], "days") > 365;
        const tooEarly = dates[1] && dates[1].diff(current, "days") > 365;
        
        return tooEarly || tooLate || endToday;
    };

    //获取下拉选择value
      function onSelect (value) {
        setSendData((prevState)=>{
            return {
                ...prevState,
                id: value
            }
        })
      }
    //button查询
    const submitData = () => {
        fetchData(sendData)
    }
    //刷新界面 
    const refreshData = () => {
        fetchData(sendData)
    }
    useEffect(() => {
        if (!requestData) return

        setTimeout(() => {
            let font = parseFloat(document.documentElement.style.fontSize)
            //--------------------------柱状图----------------------------
            barOption(font, 'bar',requestData.subScoreOrg)
            //--------------------------柱状图----------------------------

            //--------------------------折线-柱状图------------------------
            linebarOption(font, 'line-bar', requestData.subScoreTendency)
            //--------------------------折线-柱状图------------------------

            //--------------------------饼图-----------------------------
            pieDoubleOption(font, 'pie-double1', requestData.subScoreBillType)

            pieOption(font, 'pie', requestData.creditSubCauseAnalyze)
            //--------------------------饼图-----------------------------
            
            // return()=>{
            //     echarts.dispose(bar)
            // }
        },0)
        
    }, [requestData])
    return (
        <div className='container'>
            <div className="left">
                <div className="left-top">
                    <div className="left-top-box">
                        <div className="title">
                            <span className='title-data'>共享任务完成量</span>
                        </div>
                        <div className='num'>
                            <span className="digit">{requestData && requestData.completedTaskNum}</span>
                            <span className="unit">个</span>
                        </div>
                    </div>
                    <div className="left-top-box">
                    <div className="title">
                            <span className='title-data'>信用扣分任务量</span>
                        </div>
                        <div className='num'>
                            <span className="digit orange">{requestData && requestData.creditSubScoreTaskNum}</span>
                            <span className="unit">个</span>
                        </div>
                    </div>
                    <div className="left-top-box">
                    <div className="title">
                            <span className='title-data'>信用扣分明细量</span>
                        </div>
                        <div className='num'>
                            <span className="digit orange">{requestData && requestData.creditSubScoreDetail}</span>
                            <span className="unit">个</span>
                        </div>
                    </div>
                    <div className="left-top-box">
                    <div className="title">
                            <span className='title-data'>信用扣分任务占比</span>
                        </div>
                        <div className='num'>
                            <span className="digit orange">{requestData && requestData.percentOfScoreTaskNum}</span>
                            <span className="unit">%</span>
                        </div>
                    </div>
                </div>
                <div className="left-bottom">
                    <div className="left-bottom-box">
                        <div className="box1-item item1">
                            <div className="title1">
                                <span className='title-data'>扣分总额TOP10</span>
                                <span className='title-data small'>组织</span>
                            </div>
                            <div className='chart' id='bar'></div>
                        </div>
                        <div className="box1-item item2">
                            <div className="title1">
                                <span className='title-data'>扣分总额TOP10</span>
                                <span className='title-data small'>单据类型+费用项目</span>
                            </div>
                            <div className="chart" id='pie-double1'></div>
                        </div>
                    </div>
                    <div className="left-bottom-box">
                        <div className="box2-item item1">
                            <div className="title1">
                                <span className='title-data'>扣分比率趋势</span>
                            </div>
                            <div className='chart' id='line-bar'></div>
                        </div>
                        <div className="box2-item item2">
                            <div className="title1">
                                <span className='title-data'>信用扣分原因分析</span>
                            </div>
                            <div className="chart" id='pie'></div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="right">
                <div className="right-top item">
                    <div className="title1">
                        <span className='title-data'>员工信用扣分预警</span>
                    </div>
                    <div className="table-item" ref={rows_oneEl}>
                        <table>
                            <thead>
                                <tr>
                                    <th>排名</th>
                                    <th>员工工号</th>
                                    <th>员工姓名</th>
                                    <th>扣分总数</th>
                                    <th>所在公司</th>
                                </tr>
                            </thead>
                            <tbody>
                            {
                                    empoyeeScoreWarnData && empoyeeScoreWarnData.map ((item, index) => {
                                        return (
                                            <tr className={item.className} key={index}>
                                                <td className='tds'><span className={item.img}></span></td>
                                                <td>{item.number}</td>
                                                <td>{item.name}</td>
                                                <td>{item.totalSubScore}</td>
                                                <td>{item.company}</td>
                                                {/* <marquee behavior="scroll"><td>{item.company}</td></marquee> */}
                                            </tr>
                                        )
                                    })
                                
                                }
                            </tbody>
                        </table>
                        {/* 轮播调用 */}
                        <Broadcast height={divHeight} playData={requestData && requestData.empoyeeScoreWarn} />
                    </div>
                </div>
                <div className="right-bottom item">
                    <div className="title1">
                        <span className='title-data'>公司平均信用分预警</span>
                        <span className='title-data small'>(当前时点)</span>
                    </div>
                    <div className="table-item" ref={rows_oneEl}>
                        <table>
                            <thead>
                                <tr>
                                    <th>排名</th>
                                    <th>公司名称</th>
                                    <th>平均信用分</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    companyScoreWarnData && companyScoreWarnData.map ((item, index) => {
                                        return (
                                            <tr className={item.className} key={index}>
                                                <td className='tds'><span className={item.img}></span></td>
                                                <td>{item.company}</td>
                                                <td>{item.avgScore}</td>
                                            </tr>
                                        )
                                    })
                                
                                }
                            </tbody>
                        </table>
                         {/* 轮播调用 */}
                         <Broadcast2 height={divHeight2} playData={requestData && requestData.companyScoreWarn}/> 
                    </div>
                </div>
            </div>
            <div className="refresh">
                <Button icon={<ReloadOutlined/>} style={{ width: '5.4rem' }} onClick={refreshData}>刷新界面</Button>
            </div>
            <div className="share">
                <Select
                    showSearch
                    style={{ width: '11.5rem' }}
                    key={ shareDefault}
                    defaultValue={ shareDefault }
                    onSelect={onSelect}
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                >
                    {shareData && shareData.map ((item) => {
                        return (<Select.Option value={item.value} key={item.value}>{item.title}</Select.Option>)
                    })} 
                </Select>,
            </div>
            <div className="date">    
            <ConfigProvider locale={locale}>
                    <RangePicker
                        defaultValue={defaultValue}
                        value={hackValue || value}
                        ranges={{
                            今天: [moment().startOf("day"), moment().endOf("day")],
                            最近7天: [moment().subtract(6, 'days'), moment()],
                            最近1个月: [moment().subtract(1, 'month'), moment()],
                            最近3个月: [moment().subtract(3, 'month'), moment()],
                            最近半年: [moment().subtract(6, 'month'), moment()],
                            最近9个月: [moment().subtract(9, 'month'), moment()],
                            最近1年: [moment().subtract(12, 'month'), moment()],   
                        }}
                        disabledDate={disabledDate}
                        onCalendarChange={(val) => setDates(val)}
                        // onChange={(val) => setValue(val)}
                        onChange={dateChange}
                        onOpenChange={onOpenChange}
                        format={dateFormat}
                    />
                </ConfigProvider>
            </div>
            <div className='search'>
                <Button icon={<SearchOutlined />} style={{ width: '80px' }} onClick={submitData}>查询</Button>
            </div>
        </div>
    );
}

export default Credit;